import { ThresholdFilter } from '@hud/portal-dtos/webapp-common.dto';

export const DEFAULT_PAGE_SIZE = 20;
export const DEFAULT_INNER_TABLE_PAGE_SIZE = 10;
export const DEFAULT_DEBOUNCE_TIME = 200;

export const PORTAL_BASE = '/portal/v2';
export const ISSUES_BASE = '/issues';

export const DURATION_AVG_DEFAULT: ThresholdFilter = {
  operator: 'gte',
  value: 100,
};

export const NORMALIZED_RUNS_DEFAULT: ThresholdFilter = {
  operator: 'gte',
  value: 1000,
};

export const ERROR_RATE_DEFAULT: ThresholdFilter = {
  operator: 'gte',
  value: 0.001,
};

export const NORMALIZED_RUNS_PRESETS = [1, 50, 1_000, 100_000];
export const DURATION_AVG_PRESETS = [1, 10, 100, 1_000];
export const ERROR_RATE_PRESETS = [0.001, 1, 10, 50, 99];
